import {Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, OnChanges, AfterViewInit} from '@angular/core';
import {IVariantGroupingType} from "../../../../Common/Interfaces/IVariantGroupingType";
import { IVariantGrouping} from "../../../../Common/Interfaces/IVariantGrouping";
import { PropertiesService } from "../../../../Common/Services/properties.service";
import {ElementRef} from "@angular/core";
import {ProductsService} from "../../../../Common/Services/products.service";
import {IApiResponse} from "../../../../Common/Interfaces/IApiResponse";
import {GeneralHelpers} from "../../../../Common/helpers/general.helper";
import {IStyle} from "../../../../Common/Interfaces/IStyle";
@Component({
  selector: 'kws-product-variant-grid-category-browsing',
  templateUrl: './product-variant-grid-category-browsing.component.html'
})
export class ProductVariantGridCategoryBrowsingComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() cardType: string;
  @Input() variantGroupingTypes: IVariantGroupingType[];
  @Input() variantGroupingTypesSingle: IVariantGroupingType;
  @Input() groupBy: string;
  @Input() products: IVariantGrouping[];
  @Input() defaultFinish: string;
  @Input() cat: string;
  @Input() secondaryCat: string;
  @Input() type: string;
  @Input() subtype: string;
  @Input() styles: IStyle[];
  slugifiedCategory: string;

  constructor(private elementRef: ElementRef, public productsService: ProductsService, private propertiesService: PropertiesService) {
    if (this.elementRef.nativeElement.attributes.hasOwnProperty('cardtype')) {
      this.propertiesService.set('cardType', this.elementRef.nativeElement.attributes.cardType.nodeValue);
    }

    if (this.propertiesService.get('cardType')) {
      this.cardType = this.propertiesService.get('cardType');
    }
  }

  ngOnInit() {
    this.slugifyTabContainerValue();
  }

  ngOnChanges(){

  }

  slugifyTabContainerValue(){
    this.slugifiedCategory = GeneralHelpers.ensureUnique(GeneralHelpers.slugify(this.cat + ' styles'));
  }

  ngAfterViewInit(){

  }

}



// WEBPACK FOOTER //
// ./src/ts/Apps/CategoryBrowsing/src/app/product-variant-grid-category-browsing/product-variant-grid-category-browsing.component.ts